import { Component, Input, OnInit, inject } from '@angular/core';
import { Department, InternalTitle } from 'BaseDataTypes';

import { FormsModule } from '@angular/forms';
import { dialogData, genericDialogComponent } from '../genericDialog';
import { DepartmentService } from '../../Services/department-service';
import { InternalTitleService } from '../../Services/internal-titles-service';
import { MatButtonModule } from '@angular/material/button';
import { User } from 'BaseDataTypes';
import { UserService } from 'BaseServices/user-service';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { dialogInputTitleComponent } from '../../../../../../src/app/elements/dialog-input-title.component';
import { SaveButtonComponent } from '../../../../../../src/app/buttons/save-button/save-button.component';
import { DeleteButtonComponent } from '../../../../../../src/app/buttons/delete-button/delete-button.component';
import { SharedFunctionsService } from 'BaseServices/sharedFunctions.service';
@Component({
    selector: 'app-user-dialog',
    imports: [
    FormsModule,
    MatButtonModule,
    dialogInputTitleComponent,
    SaveButtonComponent,
    DeleteButtonComponent
],
    templateUrl: './user-dialog.component.html',
    styleUrl: './user-dialog.component.css'
})
export class UserDialogComponent
  extends genericDialogComponent
  implements OnInit
{
  @Input() user!: User;
  @Input() department!: Department;
  departments: Department[] = [];
  internalTitles: InternalTitle[] = [];
  nearestManagers: User[] = [];

  readonly data = inject<dialogData<User[]>>(MAT_DIALOG_DATA);

  constructor(
    public override dialogRef: MatDialogRef<UserDialogComponent>,
    private departmentService: DepartmentService,
    private internalTitleService: InternalTitleService,
    private userService: UserService,
    public sharedFunctionsService: SharedFunctionsService
  ) {
    super(dialogRef);
    this.user = this.data.data[0];
  }

  ngOnInit(): void {
    this.departmentService.getDepartments().subscribe((result) => {
      this.departments = result;

      if (this.user.departmentId) {
        this.user.department = this.departments.find(
          (d) => d.id === this.user.departmentId
        )!;
      }
    });

    this.internalTitleService.getInternalTitles().subscribe((result) => {
      this.internalTitles = result;
      if (this.user.internalTitleId) {
        this.user.internalTitle = this.internalTitles.find(
          (it) => it.id === this.user.internalTitleId
        )!;
      }
    });

    this.userService.getNearestManagers().subscribe((result) => {
      this.nearestManagers = result;
    });
  }

  get selectedDepartmentId(): number {
    return this.user.departmentId;
  }
  set selectedDepartmentId(id: number) {
    this.user.departmentId = id;
    this.user.department = this.departments.find((d) => d.id === id)!;
  }

  get selectedInternalTitleId(): number {
    return this.user.internalTitleId;
  }
  set selectedInternalTitleId(id: number) {
    this.user.internalTitleId = id;
    this.user.internalTitle = this.internalTitles.find((t) => t.id === id)!;
  }

  /**
   * Deletes a user by using the user ID in the deleteUser service
   * @returns
   */
  deleteUser() {
    if (!confirm('Er du sikker på at du vil slette Brugeren?')) {
      return;
    }
    this.userService
      .deleteUser(this.user.id)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }

  /**
   * Creates or updates an database object by parsing the user object to updateUser or createUser service.
   */
  saveChanges() {
    if (this.user.id === 0) {
      this.userService
        .createUser(this.user)
        .subscribe({
          next: (result) => {
            this.dialogRef.close(true);
          }
        });
    } else {
      this.userService
        .updateUser(this.user)
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    }
  }
}
